import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';
import { datasetCatalogueActions } from '../../constants';

const useUpdateCataloguePanels = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ index, panel }) => handler({
    type: datasetCatalogueActions.UPDATE_CATALOGUE_PANELS, category, code, index, panel,
  }), [category, code]);
};

const useUpdateDatasetCatalogueTitle = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ value, template }) => handler({
    type: datasetCatalogueActions.UPDATE_DATASET_CATALOGUE_TITLE, category, code, value, template,
  }), [category, code]);
};

const useUpdateDatasetCatalogueProperties = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({
    properties, fields, entity, template,
  }) => handler({
    type: datasetCatalogueActions.UPDATE_DATASET_CATALOGUE_PROPERTIES,
    category,
    code,
    properties,
    fields,
    entity,
    template,
  }), [category, code]);
};

const useDownloadDatasetCatalogue = ({ code }) => {
  const handler = useDispatch();
  return useCallback(() => handler({ type: actions.DOWNLOAD_CATALOGUE, code }), [code]);
};

export default {
  useDownloadDatasetCatalogue,
  useUpdateCataloguePanels,
  useUpdateDatasetCatalogueProperties,
  useUpdateDatasetCatalogueTitle,
};
